import React, { useState, useEffect } from "react";
import { Typography, Row, Col, Form, Divider, Select, Button, InputNumber, Card, Table, notification, Input } from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";

import api from "../../services/api";
import { FormatNumber } from '../../ValueObjects';
import { InputPreco, SelectIncluir } from "../../components";
import DrawerVendedores from "../../components/drawerVendedores";
import SelectPaginado from "../../components/selectPaginado";

export default function TabFaturamento({ form, valorTotalPedido, listaFormaPagamento, setListaFormaPagamento, emiteTransferencia }) {

    const [editarValores, setEditarValores] = useState(false);
    const [valorTotal, setValorTotal] = useState(0);
    const [formaPagamento, setFormaPagamento] = useState([]);
    const [condicaoPagamento, setCondicaoPagamento] = useState([]);
    const [valorJaPago, setValorJaPago] = useState(false);
    const [pagamentoTotal, setPagamentoTotal] = useState(false);
    const [editando, setEditando] = useState(false);
    const editarDesconto = () => {
        setEditarValores(!editarValores)
    };

    useEffect(() => {
        carregarDados();
        calcularTotal();
    }, []);

    useEffect(() => {
        let valor = 0;
        if (!!listaFormaPagamento && listaFormaPagamento.length > 0) {
            listaFormaPagamento.forEach((lista) => {
                valor += parseFloat(lista.pfp_valor);
            });
            if (valor >= valorTotal) {
                setPagamentoTotal(true);
            }else{
                valorRestantePgto([...listaFormaPagamento]);
            }
        } else {
            setPagamentoTotal(false);
        }
        setValorJaPago(valor);
    }, [listaFormaPagamento]);

    function carregarDados() {
        if (!!form.getFieldValue().ped_id || !!form.getFieldValue().ped_id_duplicar) {
            let pedido = !!form.getFieldValue().ped_id ? form.getFieldValue().ped_id : form.getFieldValue().ped_id_duplicar;
            api.get(`Pedido/BuscaPedido?IdPedido=${pedido}`).then(
                (res) => {
                    if (res.status === 200)
                        setListaFormaPagamento(res.data.pedidoFormaPgto);
                }
            ).catch(
                (erro) => {
                    console.log(erro);
                }
            )
        }
    };

    function valorRestantePgto(dadosTemp) {
        let restante = 0;
        let valorPago = 0;
        if (!editando) {
            dadosTemp.forEach((dados) => {
                valorPago += parseFloat(dados.pfp_valor);
            });
            restante = parseFloat(form.getFieldValue().ped_valorTotal) - valorPago;
            if (parseFloat(restante.toFixed(3)) === 0) {
                setPagamentoTotal(true);
            } else {
                setPagamentoTotal(false);
            }
            form.setFieldsValue({ pfp_valor: restante.toFixed(2) });
        } else {
            setEditando(false);
        }
    };

    function calcularTotal() {
        let valor = 0;
        valor = parseFloat(valorTotalPedido) + parseFloat(!!form.getFieldValue().pdi_valorfrete ? form.getFieldValue().pdi_valorfrete : 0) + parseFloat(!!form.getFieldValue().pdi_valoroutrasdespesas ? form.getFieldValue().pdi_valoroutrasdespesas : 0);
        setValorTotal(valor);
        form.setFieldsValue({ ped_valorTotal: valor.toFixed(2) });
        valorRestantePgto([...listaFormaPagamento]);
    };

    function listarCondicao(fpg_id, dadosIniciais = false) {
        if (!dadosIniciais) {
            form.setFieldsValue({ cpg_id: null });
        }

        api.get(`CondicaoPagamento/Listar?Ativo=true&codigoFormaPagamento=${fpg_id}&PageSize=500`).then(
            (res) => {
                if (res.status === 200) {
                    setCondicaoPagamento(res.data.items);
                }
            }
        ).catch(
            (erro) => {
                console.log(erro);
            }
        );
    };

    async function adicionarFormaPagamento() {
        let dadosTemp = [...listaFormaPagamento];
        if (!!form.getFieldValue().fpg_id && (condicaoPagamento.length === 0 || !!form.getFieldValue().cpg_id)) {
            if (listaFormaPagamento.find((formas) => (
                formas.fpg_id === form.getFieldValue().fpg_id && formas.cpg_id === form.getFieldValue().cpg_id
            ))) {
                let dados = listaFormaPagamento.find((formas) => (
                    formas.fpg_id === form.getFieldValue().fpg_id && formas.cpg_id === form.getFieldValue().cpg_id
                ));
                if (parseFloat(form.getFieldValue().ped_valorTotal) < parseFloat(form.getFieldValue().pfp_valor) + (parseFloat(valorJaPago) - dados.pfp_valor)) {
                    notification.warning({ message: 'Aviso', description: 'Valor de pagamento maior que o total do pedido!' });
                    return;
                } else {
                    dados.pfp_valor = parseFloat(form.getFieldValue().pfp_valor);
                    setListaFormaPagamento(dadosTemp);
                    form.setFieldsValue({ fpg_id: null });
                    form.setFieldsValue({ cpg_id: null });
                    valorRestantePgto(dadosTemp);
                }
            } else {
                if (parseFloat(form.getFieldValue().ped_valorTotal) < parseFloat(form.getFieldValue().pfp_valor) + parseFloat(valorJaPago)) {
                    notification.warning({ message: 'Aviso', description: 'Valor de pagamento maior que o total do pedido!' });
                } else {
                    let dadosFormaPagamento = (await api.get(`FormaPagamento/Get?id=${form.getFieldValue().fpg_id}`)).data;

                    let dadosCondicoesPagamento = condicaoPagamento.filter((condicao) => { return condicao.cpg_id === form.getFieldValue().cpg_id; })[0];
                    dadosTemp.push({
                        fpg_id: form.getFieldValue().fpg_id,
                        fpg_descricao: dadosFormaPagamento.fpg_descricao,
                        cpg_descricao: !!dadosCondicoesPagamento && dadosCondicoesPagamento.cpg_descricao ? dadosCondicoesPagamento.cpg_descricao : '',
                        cpg_id: !!form.getFieldValue().cpg_id ? form.getFieldValue().cpg_id : null,
                        pfp_valor: parseFloat(form.getFieldValue().pfp_valor)
                    });
                    setListaFormaPagamento(dadosTemp);

                    form.setFieldsValue({ fpg_id: null });
                    form.setFieldsValue({ cpg_id: null });
                    valorRestantePgto(dadosTemp);
                }
            }
        } else {
            notification.warning({ message: 'Aviso', description: 'Informe a forma e a condicao de pagamento!' });
        }
    };

    function calculaDesconto(campo) {
        let percValor = (!!form.getFieldValue().percentualDesconto ? form.getFieldValue().percentualDesconto : 0);
        let valor = (!!form.getFieldValue().ped_valorTotalDesc ? form.getFieldValue().ped_valorTotalDesc : 0);

        if (campo === 'perc') {
            valor = (percValor * valorTotalPedido) / 100;
            form.setFieldsValue({ ped_valorTotalDesc: parseFloat(valor).toFixed(2) });
        } else if (campo === 'valor') {
            valor = (valor / valorTotalPedido) * 100;
            valor = parseFloat(valor).toFixed(2);
            form.setFieldsValue({ percentualDesconto: valor });
        }

        recalcularTotalPedido();
    };

    function calculaAcrescimo(campo) {
        let perc = (!!form.getFieldValue().percentualAcrescimo ? form.getFieldValue().percentualAcrescimo : 0);
        let valor = (!!form.getFieldValue().ped_valorTotalAcre ? form.getFieldValue().ped_valorTotalAcre : 0);

        if (campo === 'perc') {
            valor = (perc * valorTotalPedido) / 100;
            form.setFieldsValue({ ped_valorTotalAcre: parseFloat(valor).toFixed(2) });
        } else if (campo === 'valor') {
            valor = (100 * valor) / valorTotalPedido;
            form.setFieldsValue({ percentualAcrescimo: parseFloat(valor).toFixed(2) })
        }

        recalcularTotalPedido();
    };

    function recalcularTotalPedido() {
        let total = 0.0;
        total = parseFloat(valorTotal) + parseFloat(form.getFieldValue().ped_valorTotalAcre) - parseFloat(form.getFieldValue().ped_valorTotalDesc);
        form.setFieldsValue({ ped_valorTotal: total.toFixed(2) });
    };

    function editarFormasPagamento(forma) {
        setPagamentoTotal(false);
        setEditando(true);
        form.setFieldsValue({ fpg_id: forma.fpg_id });
        form.setFieldsValue({ cpg_id: forma.cpg_id });
        form.setFieldsValue({ pfp_valor: forma.pfp_valor });
    };

    function removerFormaPagamento(forma) {
        let dadosTemp = [...listaFormaPagamento];
        dadosTemp = dadosTemp.filter((dados) => dados !== forma);
        setListaFormaPagamento(dadosTemp);
        valorRestantePgto(dadosTemp);
    };

    return (
        <div className="m-t-16">
            <Row align="middle" justify="center">
                <Col xs={24} sm={24} md={24} lg={15} xl={15}>
                    <Card extra={
                        <Typography.Title level={3}>
                            Resumo do Pedido
                        </Typography.Title>
                    }>
                        <Row gutter={[8, 0]} className="text-right">
                            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                                <Form.Item label="Subtotal do Pedido (R$)">
                                    <b>{FormatNumber(valorTotalPedido, true)}</b>
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                                <Form.Item label="Valor do Frete (R$)">
                                    <b>{FormatNumber(form.getFieldValue().pdi_valorfrete, true)}</b>
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                <Form.Item label="Outras Despesas (R$)">
                                    <b>{FormatNumber(form.getFieldValue().pdi_valoroutrasdespesas, true)}</b>
                                </Form.Item>
                            </Col>
                        </Row>
                        {!emiteTransferencia && <Row justify="end" gutter={[0, 8]} className="m-t-b-5">
                            <Col>
                                <Button onClick={editarDesconto} icon={<EditOutlined />} type="primary">
                                    Editar Descontos/Acréscimos
                                </Button>
                            </Col>
                        </Row>}
                        {editarValores &&
                            <div>
                                <Row justify="center" gutter={[8, 0]}>
                                    <Col xs={24} sm={10} md={10} lg={10} xl={10}>
                                        <Form.Item label="Percentual de Desconto" name="percentualDesconto">
                                            <InputNumber
                                                defaultValue={0}
                                                min={0}
                                                max={100}
                                                formatter={value => `${value}%`}
                                                parser={value => value.replace('%', '')}
                                                onChange={() => { calculaDesconto('perc') }}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col span={4} className="text-center t-mob-573">
                                        <b> ou </b>
                                    </Col>
                                    <Col xs={24} sm={10} md={10} lg={10} xl={10}>
                                        <InputPreco name={'ped_valorTotalDesc'} label={'Valor do Desconto (R$)'} onChange={() => { calculaDesconto('valor') }} />
                                    </Col>
                                </Row>
                                <Row justify="center" gutter={[8, 0]}>
                                    <Col xs={24} sm={10} md={10} lg={10} xl={10}>
                                        <Form.Item label="Percentual de Acréscimo" name="percentualAcrescimo">
                                            <InputNumber
                                                defaultValue={0}
                                                min={0}
                                                max={100}
                                                formatter={value => `${value}%`}
                                                parser={value => value.replace('%', '')}
                                                onChange={() => { calculaAcrescimo('perc') }}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col span={4} className="text-center t-mob-573">
                                        <b> ou </b>
                                    </Col>
                                    <Col xs={24} sm={10} md={10} lg={10} xl={10}>
                                        <InputPreco name={'ped_valorTotalAcre'} label={'Valor do Acréscimo (R$)'} onChange={() => { calculaAcrescimo('valor') }} />
                                    </Col>
                                </Row>
                            </div>
                        }
                        <Row justify="end">
                            <Col>
                                IPI (R$): <b> 0,00</b>
                            </Col>
                        </Row>
                        <Row justify="end">
                            <Col>
                                Substituição Tributária (R$): <b> 0,00</b>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <Divider className="m-t-b-5" />
                            </Col>
                        </Row>
                        <Row justify="end">
                            <Col>
                                <Typography.Title level={3}>
                                    Total do Pedido
                                </Typography.Title>
                            </Col>
                        </Row>
                        <Row justify="end">
                            <Col>
                                <strong className="f-18"><InputPreco name="ped_valorTotal" disabled={true} /></strong>
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
            <Row className="m-t-16">
                <Col span={24}>
                    <Form.Item label="Informações Adicionais do Pedido" name="ped_observacao">
                        <Input.TextArea placeholder="Informações Adicionais do Pedido" />
                    </Form.Item>
                </Col>
            </Row>
            {!pagamentoTotal && <Row gutter={[8, 0]}>
                {!emiteTransferencia && <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                    <Form.Item label="Forma de Pagamento" name="fpg_id" rules={[{ required: true, message: 'Informe a forma de pagamento' }]}>
                        <SelectPaginado url="FormaPagamento/Listar?Ativo=true&Order=+fpg_descricao" placeholder="Selecione Forma de Pagamento" form={form} name="fpg_id" onChangeFunction={(registro) => { listarCondicao(registro) }} conteudo={
                            fp => (<Select.Option value={fp.fpg_id} key={fp.key}>{fp.fpg_descricao}</Select.Option>)
                        } />
                    </Form.Item>
                </Col>}
                {condicaoPagamento.length > 0 && <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                    <Form.Item label="Condição de Pagamento" name="cpg_id" rules={[{ required: true, message: 'Informe a condicao de pagamento' }]}>
                        <Select placeholder="Selecione Condição de Pagamento">
                            {condicaoPagamento.map((condicao) => (
                                <Select.Option value={condicao.cpg_id} key={condicao.cpg_id}>{condicao.cpg_descricao}</Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>}
                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                    {!emiteTransferencia &&
                        <Row gutter={[8, 0]}>
                            <Col xs={24} sm={12} md={14} lg={14} xl={14}>
                                <InputPreco name="pfp_valor" label="Valor do Pagamento (R$)" />
                            </Col>
                            <Col xs={24} sm={12} md={10} lg={10} xl={10}>
                                <Button icon={<PlusOutlined />} type="primary" onClick={() => (adicionarFormaPagamento())} className="t-mob-573" block>
                                    Adicionar
                                </Button>
                            </Col>
                        </Row>
                    }
                </Col>
            </Row>}
            <Row gutter={[0, 24]}>
                <Col span={24}>
                    <div className="tabela mt-dif">
                        {!!listaFormaPagamento && listaFormaPagamento.length > 0 && <Table columns={[
                            {
                                title: 'Formas de Pagamento',
                                align: 'left',
                                render: ({ fpg_descricao, cpg_descricao }) => (
                                    <div>
                                        <b>
                                            {fpg_descricao} {!!cpg_descricao ? `/ ${cpg_descricao}` : ''}
                                        </b>
                                    </div>
                                ),
                            },
                            {
                                title: 'Valor (R$)',
                                align: 'right',
                                render: ({ pfp_valor }) => (
                                    <div>
                                        <b>{FormatNumber(pfp_valor, true)}</b>
                                    </div>
                                ),
                            },
                            {
                                title: 'Ações',
                                dataIndex: '',
                                key: 'x',
                                align: 'center',
                                width: 65,
                                render: (record) => (
                                    <div>
                                        <Row align="middle" justify="center" gutter={[5, 0]}>
                                            <Col>
                                                <Button icon={<EditOutlined />} onClick={() => {
                                                    editarFormasPagamento(record);
                                                }} />
                                            </Col>
                                            <Col>
                                                <Button icon={<DeleteOutlined />} onClick={() => {
                                                    removerFormaPagamento(record);
                                                }} />
                                            </Col>
                                        </Row>
                                    </div>
                                ),
                            },
                        ]} footer={() => {
                            let totalPagamento = 0;
                            listaFormaPagamento.map((dados) => {
                                totalPagamento += parseFloat(dados.pfp_valor);
                            })
                            return (
                                <Row align="middle" justify="end" gutter={[8, 0]}>
                                    <Col>
                                        <span className="f-14"> Total dos Pagamentos (R$):</span>
                                    </Col>
                                    <Col>
                                        <Form.Item name="pfp_valor">
                                            <strong className="f-21">{FormatNumber(totalPagamento, true)}</strong>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            )
                        }} dataSource={listaFormaPagamento}
                        />}
                    </div>
                </Col>
            </Row>
        </div>
    );
}